import { useState, useCallback } from 'react';
import { TemplatesCard } from '../TemplatesCard';
import { Box } from '@startuptools/ui/Box';
import { Typography } from '@startuptools/ui/Typography';
import { Swiper, type SwiperClass, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Global, css } from '@emotion/react';
import { isNil } from 'lodash-es';
import { type DynamicContent } from './types';

export const MobileMainDynamicDivContent = ({ contentObject }: { contentObject: DynamicContent }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeContent = contentObject[activeIndex];

  const onSlideChange = useCallback((swiper: SwiperClass) => {
    setActiveIndex(swiper.realIndex);
  }, []);

  return (
    <>
      <Global
        styles={css`
          .custom-swiper .swiper-pagination {
            position: initial;
            margin-top: 1.5rem;
          }
          .custom-swiper .swiper-pagination-bullet {
            background-color: #7f7f7f;
          }
          .custom-swiper .swiper-pagination-bullet-active {
            background-color: #5271ff;
          }
        `}
      />
      <Box className="custom-swiper">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={50}
          slidesPerView={1}
          loop
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 4200,
          }}
          centeredSlides
          onSlideChange={onSlideChange}
        >
          {contentObject.map(content => (
            <SwiperSlide key={content.referToUrl}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <TemplatesCard {...content} />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      <Typography
        level="body-md"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'start',
          padding: '1.5rem 1.5rem 0rem 1.5rem',
          minHeight: '12rem',
        }}
      >
        {!isNil(activeContent) ? activeContent.description : ''}
      </Typography>
    </>
  );
};
